import FieldPermissionDelete from './FieldPermissionDelete'
export {FieldPermissionDelete}
export default FieldPermissionDelete
